angular.module('storefrontApp')
    .component('addToCompareButton', {
        templateUrl: 'themes/assets/js/products-compare/add-to-compare-button.tpl.html',
        bindings: {
            productId: '<',
            buttonType: '<',
            customClass: '<',
            buttonWidth: '<',
        },
        controller: [
            '$rootScope',
            'catalogService',
            'dialogService',
            'compareProductService',
            function (
                $rootScope,
                catalogService,
                dialogService,
                compareProductService,
            ) {
                const $ctrl = this;

                $ctrl.showButtonName = $ctrl.buttonType !== 'small';

                $ctrl.$onInit = function () {
                    $ctrl.containProduct = compareProductService.isInProductCompareList($ctrl.productId);
                };

                $ctrl.addProductToCompareList = function (event) {
                    event.preventDefault();
                    catalogService.getProduct($ctrl.productId)
                        .then(function (response) {
                            const product = response.data[0];
                            const productQuantity = compareProductService.getProductsCount();
                            const templateName = 'storefront.product-compare-list-dialog.tpl';
                            const controllerName = 'productCompareListDialogController';

                            if (productQuantity === 4) {
                                dialogService.showDialog(
                                    { capacityExceeded: true },
                                    controllerName,
                                    templateName,
                                );

                                return;
                            }

                            if (!$ctrl.containProduct && productQuantity < 4) {
                                compareProductService.addProduct($ctrl.productId);
                                dialogService.showDialog(
                                    product,
                                    controllerName,
                                    templateName,
                                );
                                $rootScope.$broadcast('productCompareListChanged');
                            } else {
                                const existingProduct = product;

                                dialogService.showDialog(
                                    existingProduct,
                                    controllerName,
                                    templateName,
                                );

                                return;
                            }
                            $ctrl.containProduct = true;
                        });
                };
            }],
    });
